import React from "react";
import "./OperationTransferIndicator.css";

export default function OperationTransferIndicator({ direction, label, className = "", ...events }) {
  if (!label) return null;
  return (
    <span
      className={`operation-transfer-marker operation-transfer-marker--${direction} ${className}`.trim()}
      role="img"
      tabIndex={0}
      title={label}
      aria-label={label}
      {...events}
    >
      <svg viewBox="0 0 16 24" aria-hidden="true" focusable="false">
        <path d="M2 2 L14 12 L2 22 L5 12 Z" fill="currentColor" />
      </svg>
    </span>
  );
}
